module.exports = __webpack_public_path__ + "img/heart-3-fill.0a89f333.svg";